import { useLocation } from "react-router-dom";
import { usePersonaDecision } from "./store";
import { linksFor } from "./personaLinks";
import { PersonaLinkGrid } from "./PersonaLinkGrid";

/**
 * Site-wide adaptive band, rendered just above the footer on every page by the layout.
 * Appears only once a visitor has been classified (so unclassified visits and the A/B
 * control group are untouched) and never on the homepage, which carries its own spotlight.
 */
export function PersonaNextSteps() {
  const { persona, inferred, variant } = usePersonaDecision();
  const { pathname } = useLocation();

  if (persona === "unknown" || pathname === "/") return null;

  const { heading, links } = linksFor(persona);

  return (
    <PersonaLinkGrid
      heading={heading}
      links={links}
      event="cta_nextsteps"
      persona={inferred}
      variant={variant}
      className="py-14 border-t border-white/5 bg-white/[0.01]"
    />
  );
}
